import axios from 'axios'
import httpConfig from '@/config/http-config'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}
const http = axios.create(config)

http.interceptors.request.use(
  function (config) {
    // 如果需要取消请求，请求自身有取消配置时例外
    if (!config.cancelToken) {
      http.cancel.token && (config.cancelToken = http.cancel.token)
    }
    // Do something before request is sent
    return httpConfig(config)
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)

// Add a response interceptor
http.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  },
)

// 允许注册到vue中
http.install = function (Vue, options) {
  Object.defineProperties(Vue.prototype, {
    $http: {
      get () {
        return http
      },
    },
  })
}

// 创建取消请求
http.cancel = Function.prototype
http.cancel.token = null
http.createCancel = () => {
  const source = axios.CancelToken.source()
  http.cancel = (message = null) => {
    source.cancel(message)
    http.cancel = Function.prototype
    http.cancel.token = null
  }
  http.cancel.token = source.token
}

export default http
